/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Bo as Bo,
  rec_BuscarConversacion as BuscarConversacion,
  rec_JSXRuntime as JSXRuntime,
  rec_M2 as M2,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_SelectorMultiple as SelectorMultiple,
  rec_d4 as d4,
  rec_f4 as f4,
  rec_j2 as j2,
  rec_k2 as k2,
  rec_p4 as p4,
  rec_ra as ra,
} from "../../runtime/index.jsx";
export function BuscarPersonaOrganigrama(e) {
  let t = (0, ReactCompiler.c)(35),
    { filas: n, filtro: r, onFiltro: i, personas: a, onBuscar: o } = e,
    s = a === void 0 ? null : a,
    c;
  t[0] !== n || t[1] !== r
    ? ((c = j2(n, r)), (t[0] = n), (t[1] = r), (t[2] = c))
    : (c = t[2]);
  let l = c,
    u;
  t[3] === r
    ? (u = t[4])
    : ((u = k2.some((e) => r[e.clave])), (t[3] = r), (t[4] = u));
  let d = u,
    f;
  t[5] === s
    ? (f = t[6])
    : ((f = (s ?? []).filter(p4).map(f4)), (t[5] = s), (t[6] = f));
  let p = f,
    m,
    h,
    _,
    v,
    y,
    b;
  if (
    t[7] !== p ||
    t[8] !== r ||
    t[9] !== d ||
    t[10] !== o ||
    t[11] !== i ||
    t[12] !== l ||
    t[13] !== s
  ) {
    m = Symbol.for(`react.early_return_sentinel`);
    bb0: {
      if (!s) {
        m = (
          <div
            className={`${Bo} flex flex-col gap-2 lg:flex-row lg:items-end`}
            children={[
              <div
                className={`grid flex-1 gap-2 sm:grid-cols-2 lg:grid-cols-4`}
                children={n()}
              />,
              d && e(),
            ]}
          />
        );
        break bb0;
      }
      function e() {
        return (
          <button
            type={`button`}
            onClick={() => i({})}
            className={`inline-flex min-h-11 shrink-0 items-center gap-1 self-start rounded-full px-3 text-sm font-medium text-(--accent) hover:bg-(--accent-bg) lg:self-auto`}
            children={[
              (0, JSXRuntime.jsx)(ra, {
                className: `h-4 w-4`,
              }),
              ` Quitar filtro`,
            ]}
          />
        );
      }
      function n() {
        return k2.map((e, t) => {
          let n = k2[t - 1],
            a = !n || !!r[n.clave];
          return (
            <label
              key={e.clave}
              className={`flex min-w-0 flex-col gap-1 text-xs text-(--text)`}
              children={[
                e.titulo,
                <SelectorMultiple
                  value={r[e.clave] ?? ``}
                  onChange={(t) => i(M2(r, e.clave, t))}
                  placeholder={`Todas`}
                  disabled={!a}
                  opciones={l[e.clave].map(d4)}
                />,
              ]}
            />
          );
        });
      }
      y = `${Bo} flex flex-col gap-3`;
      let a = n();
      (t[20] === a
        ? (b = t[21])
        : ((b = (
            <div
              className={`grid gap-2 sm:grid-cols-2 lg:grid-cols-4`}
              children={a}
            />
          )),
          (t[20] = a),
          (t[21] = b)),
        (h = `flex flex-col gap-2 sm:flex-row sm:items-center`));
      let c;
      (t[22] === o
        ? (c = t[23])
        : ((c = (e) => {
            (o(Number(e)), document.activeElement?.blur?.());
          }),
          (t[22] = o),
          (t[23] = c)),
        t[24] !== p || t[25] !== c
          ? ((_ = (
              <div
                className={`min-w-0 flex-1`}
                children={
                  <BuscarConversacion
                    value={``}
                    onChange={c}
                    opciones={p}
                    placeholder={`Buscar a una persona en el organigrama…`}
                  />
                }
              />
            )),
            (t[24] = p),
            (t[25] = c),
            (t[26] = _))
          : (_ = t[26]),
        (v = d && e()));
    }
    ((t[7] = p),
      (t[8] = r),
      (t[9] = d),
      (t[10] = o),
      (t[11] = i),
      (t[12] = l),
      (t[13] = s),
      (t[14] = m),
      (t[15] = h),
      (t[16] = _),
      (t[17] = v),
      (t[18] = y),
      (t[19] = b));
  } else
    ((m = t[14]),
      (h = t[15]),
      (_ = t[16]),
      (v = t[17]),
      (y = t[18]),
      (b = t[19]));
  if (m !== Symbol.for(`react.early_return_sentinel`)) return m;
  let x;
  t[27] !== h || t[28] !== _ || t[29] !== v
    ? ((x = <div className={h} children={[_, v]} />),
      (t[27] = h),
      (t[28] = _),
      (t[29] = v),
      (t[30] = x))
    : (x = t[30]);
  let S;
  return (
    t[31] !== x || t[32] !== y || t[33] !== b
      ? ((S = <div className={y} children={[b, x]} />),
        (t[31] = x),
        (t[32] = y),
        (t[33] = b),
        (t[34] = S))
      : (S = t[34]),
    S
  );
}
